// oxlint-disable-next-line no-restricted-imports
import { useDispatch as useReduxDispatch } from 'react-redux';

import type { GlobalDispatch } from '#reducers/state';

export function useDispatch(): GlobalDispatch {
  return useReduxDispatch();
}
